import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/model';
import { AuthProvider } from 'src/app/providers';
import { CommonService, ToasterService, UserService } from 'src/app/services';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  @ViewChild('regForm') regForm: NgForm;
  code: string;
  PROMO: string;
  user: User = new User();
  isCodeValid: boolean = false;
  submitting: boolean = false;
  captchaVisible: boolean = false;
  hasPassword: boolean = true;
  showSuccessPage: boolean = false;

  orgName: string = '';
  phoneNumber: string = '';
  PASSWORD: string = '';
  IS_AGREE: boolean = false;

  constructor(
    private authProvider: AuthProvider,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToasterService,
    public commonService: CommonService,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    // Get Code from the routing params
    this.code = this.route.snapshot.queryParams.code;

    this.route.queryParams
      .subscribe(params => {
          if (params?.promo) {
            this.PROMO = params.promo;
          }
        }
      );

    if (!this.code) {
      this.isCodeValid = false;
    } else {
      this.isCodeValid = true;
    }
    // Check code is valid or not
    this.authProvider.getUserByCode(this.code).subscribe(response => {
      if (response.success) {
        this.isCodeValid = true;
        this.user = User.parse(response.result);
        if (this.user?.ORGANIZATION?.ID) {
          this.orgName = this.user.ORGANIZATION.NAME;
          this.hasPassword = !!response.result.HAS_PASSWORD;
        } else {
          this.router.navigateByUrl(`/register?code=${this.code}`);
        }
      } else {
        /** If code is invalid Route user to login(default) page */
        this.isCodeValid = false;
        setTimeout(() => { this.router.navigate(['/']); }, 4000);
      }
    }, err => {
      console.error(err);
    });
  }

  registerUser() {
    if (this.IS_AGREE) {
      this.user.TELEPHONE = this.phoneNumber ? this.phoneNumber.replace(/ /g, "") : '';
      const params = {
        USER: this.user,
        PASSWORD: this.PASSWORD
      }
      if(this.PROMO){
        params['PROMO'] = this.PROMO;
      }
      this.authProvider.register(params, this.code).subscribe((response) => {
        this.submitting = false;
        if (response.success) {
          this.showSuccessPage = true;
          localStorage.setItem('IV-TOKEN', response.result.token);
          this.userService.setUser(User.parse(response.result.profile));
          setTimeout(() => {
            this.router.navigate(['/dashboard']);
          }, 4000);
        } else {
          this.toastr.error(response.error.txt);
        }
      }, () => {
        this.submitting = false;
      })
    }
  }
}
